import { render, staticRenderFns } from "./MPNResearchDetailCell.vue?vue&type=template&id=561751f9&scoped=true"
import script from "./MPNResearchDetailCell.vue?vue&type=script&lang=js"
export * from "./MPNResearchDetailCell.vue?vue&type=script&lang=js"
import style0 from "./MPNResearchDetailCell.vue?vue&type=style&index=0&id=561751f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561751f9",
  null
  
)

export default component.exports